











// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat' 

@Component({
  name: 'Bios'
})
export default class Bios extends mixins(BasePlat) {  

  get BiosDic(){
    return this.$store.myGetters.biosDic 
  }
    
}
